import React from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

type ExpandIconProps<RecordType> = {
  expanded: boolean,
  onExpand: (record: RecordType, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  record: RecordType,
};

export function ExpandIcon<RecordType>({ expanded, onExpand, record }: ExpandIconProps<RecordType>) {
  return (expanded ? (
    <UpOutlined
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => onExpand(record, e)}
    />
  ) : (
    <DownOutlined
      onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => onExpand(record, event)}
    />
  ));
}
